import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { tsXLXS } from 'ts-xlsx-export';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  Login, ContaBancaria, Recurso, Convenio, EddyAutoComplete,
  GlobalService, FuncaoService, Relatorio, Coluna, PlanoConta
} from 'eddydata-lib';
import {
  ContaBancariaService, ConvenioService, PagamentoExtraService, PagamentoService,
  RecursoService
} from 'administrativo-lib';
import { PlanoContaService } from 'projects/contabil/src/app/plano-conta/service/plano-conta.service';

@Component({
  selector: 'app-pagamento-extra-rpt',
  templateUrl: './pagamento-extra-rpt.component.html'
})
export class PagamentoExtraRptComponent implements OnInit, OnDestroy {

  login: Login = new Login();
  conta: ContaBancaria;
  plano: PlanoConta;
  recurso: Recurso;
  aplicacao: Recurso;
  convenio: Convenio;
  filtroPlano: boolean;
  filtroConta: boolean;
  filtroConvenio: boolean;
  filtroRecurso: boolean;
  filtroAplicacao: boolean;
  public selectedOrdem: string;

  public ptBR: any;

  public listaRelatorio: Array<any>;
  public listaConvenio: Array<Convenio>;
  public contaAutoComplete: EddyAutoComplete<ContaBancaria>;
  public recursoAutoComplete: EddyAutoComplete<Recurso>;
  public aplicacaoAutoComplete: EddyAutoComplete<Recurso>;
  public planoAutoComplete: EddyAutoComplete<PlanoConta>;
  public relatorio = '1';
  public dataInicial: string;
  public dataFinal: string;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    private router: Router,
    protected injector: Injector,
    protected messageService: MessageService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected contaService: ContaBancariaService,
    protected recursoService: RecursoService,
    protected planoService: PlanoContaService,
    protected convenioService: ConvenioService,
    protected pagamentoService: PagamentoExtraService) {
  }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.login = GlobalService.obterSessaoLogin();
    this.selectedOrdem = 'ord1';
    this.listaRelatorio = [];
    this.listaRelatorio.push({ label: 'TODOS OS PAGAMENTOS EXTRA ORÇAMENTÁRIOS', value: 1 });
    this.listaRelatorio.push({ label: 'PAGAMENTOS ORÇAMENTÁRIOS EXTRA ANULADOS', value: 2 });
    this.carregarAutoCompletes();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public gerarRelatorio() {
    const parametros = {};
    if (!this.dataInicial || !this.dataFinal) {
      this.messageService.add({ severity: 'warn', summary: 'Mensagem', detail: 'Informe a data inicial e final!' });
      return;
    }

    parametros['exercicio_id'] = this.login.exercicio.id;
    parametros['orgao_id'] = this.login.orgao.id;

    parametros['data_pagamento$ge'] = this.funcaoService.converteDataSQL(this.dataInicial);
    parametros['data_pagamento$le'] = this.funcaoService.converteDataSQL(this.dataFinal);

    if (this.filtroConvenio) {
      parametros['convenio.numero'] = this.convenio.numero;
    }

    if (this.filtroConta) {
      parametros['conta.id'] = this.conta.id;
    }

    if (this.filtroPlano) {
      parametros['empenho.ficha.plano.id'] = this.plano.id;
    }

    if (this.filtroRecurso) {
      parametros['empenho.ficha.recurso.id'] = this.recurso.id;
    }

    if (this.filtroAplicacao) {
      parametros['empenho.ficha.aplicacao.id'] = this.aplicacao.id;
    }

    if (this.relatorio === '2') {
      parametros['anulacao'] = true;
    }

    if (this.selectedOrdem === 'ord1') {
      parametros['orderBy'] = 'data_pagamento';
    } else if (this.selectedOrdem === 'ord2') {
      parametros['orderBy'] = 'conta.numero_conta';
    } else if (this.selectedOrdem === 'ord3') {
      parametros['orderBy'] = 'empenho.ficha.plano.nome';
    }
    parametros['relations'] = 'conta,empenho.ficha,empenho.ficha.plano,'
      + 'empenho.ficha.recurso,empenho.ficha.aplicacao';

    this.pagamentoService.filtrar(1, -1,
      parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((lista) => {
        this.imprimir(`PAGAMENTOS EXTRAS ORÇAMENTÁRIOS PERÍODO DE ${this.dataInicial} à ${this.dataFinal} `,
          this.login.usuario.nome, this.login.orgao.nome, this.login.brasao, 'landscape',
          'Listagem pagamentos', ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto'], lista.content);
      });
  }

  private imprimir(
    titulo: string, usuario: string, orgao: string,
    brasao: string, orientacao: 'landscape' | 'portrait', nomepdf?: string, largura?: string[], lista?: any[]) {
    Relatorio.imprimir(titulo, usuario, orgao, brasao, lista, this.colunas(), orientacao, nomepdf, largura, ['valor_pago']);
  }

  colunas(): string[] | Coluna[] {
    return [
      { titulo: 'Data', coluna: 'data_pagamento' },
      { titulo: 'Conta N˚', coluna: 'conta.numero_conta' },
      { titulo: '', coluna: 'conta.digito_conta' },
      { titulo: 'Descrição conta', coluna: 'conta.nome' },
      { titulo: 'Documento', coluna: 'documento' },
      { titulo: 'Plano', coluna: 'empenho.ficha.plano.codigo' },
      { titulo: '', coluna: 'empenho.ficha.plano.nome' },
      { titulo: 'Recurso', coluna: 'empenho.ficha.recurso.codigo' },
      { titulo: '', coluna: 'empenho.ficha.aplicacao.codigo' },
      { titulo: 'Aplicação', coluna: 'empenho.ficha.aplicacao.nome' },
      { titulo: 'Valor', coluna: 'valor_pago', decimais: 2, alignment: 'right' }
    ];
  }

  exportarXlxs() {
    const parametros = {};
    parametros['orgao.id'] = this.login.orgao.id;
    parametros['relations'] = 'conta,liquidacao,empenho.ficha,empenho.subelemento,'
      + 'empenho.ficha.recurso,empenho.ficha.aplicacao';
    parametros['orderBy'] = 'codigo';
    this.pagamentoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          const listaItens = new Array();
          for (const item of lista.content) {
            const entity = {
              codigo: item.codigo,
              cpf: item.cpf,
              nome: item.pessoa.nome,
              endereco: item.pessoa.endereco,
              bairro: item.pessoa.bairro,
              cidade: item.pessoa.municipio,
              telefone: item.pessoa.telefone,
              cep: item.pessoa.cep
            };
            listaItens.push(entity);
          }
          tsXLXS().exportAsExcelFile(listaItens).saveAsExcelFile('funcionarios');
        },
        () => alert('erro ao retornar lista')
      );
  }

  private carregarAutoCompletes() {
    // autocomplete para conta
    this.contaAutoComplete = new EddyAutoComplete(null, this.contaService,
      'id', ['numero_conta', 'digito_agencia', 'nome'], { orgao_id: this.login.orgao.id, relations: 'banco', orderBy: 'nome' },
      { number: ['id'], text: ['nome'] }
    );

    // autocomplete para plano
    this.planoAutoComplete = new EddyAutoComplete(null, this.planoService,
      'id', ['codigo', 'nome'], { escrituracao: true, exercicio_id: this.login.exercicio.id, orderBy: 'nome' },
      { number: ['codigo'], text: ['nome'] }
    );

    // autocomplete para recurso
    this.recursoAutoComplete = new EddyAutoComplete(null, this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 0, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );

    // autocomplete para aplicacao
    this.aplicacaoAutoComplete = new EddyAutoComplete(null, this.recursoService,
      'id', ['codigo', 'nome'], { nivel: 1, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );
  }

  sair() {
    this.funcaoService.navegarPara(this.login.usuario.sistema, this.router);
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
        this.router.navigate(['/tesouraria']);
        break;
      default:
        this.sair();
        break;
    }
  }
}
